import { Pipe, PipeTransform } from '@angular/core';
import { StoreType, storeTypes } from '../../../models/business.model';

@Pipe({
  name: 'storeType'
})
export class StoreTypePipe implements PipeTransform {
  transform(value: StoreType | StoreType[], separator?: string): string {
    // Handle array of tags
    if (Array.isArray(value)) {
      const titles = value.map((tag) => this.getStoreTypeTitle(tag));
      return titles.join(separator || ', ');
    }

    // Handle single tag
    return this.getStoreTypeTitle(value);
  }

  private getStoreTypeTitle(tag: StoreType): string {
    if (tag === storeTypes.pets) {
      return 'pets';
    } else if (tag === storeTypes.nail) {
      return 'nails';
    }
    return tag;
  }
}

